/**
 * mobile-menu hardcodes mobileStrategyName to "mobile" (bottom sheet).
 * Force drawer strategy on small screens for full-screen side navigation.
 * Patch page-navigation transitions for cleaner drill-down slides.
 */
(() => {
  const TRANSITION_MS = 260;

  const applyDrawerStrategy = (menu) => {
    if (!menu?.setStrategy) return;
    if (window.matchMedia('(max-width: 767px)').matches) {
      menu.setStrategy('drawer');
    }
  };

  const patchMobileMenu = () => {
    const MobileMenu = customElements.get('mobile-menu');
    if (!MobileMenu) return false;

    Object.defineProperty(MobileMenu.prototype, 'mobileStrategyName', {
      get() {
        return this.getAttribute('mobile-strategy') || 'drawer';
      },
      configurable: true,
    });

    applyDrawerStrategy(document.getElementById('MobileMenu'));
    return true;
  };

  const patchPageNavigation = () => {
    const PageNavigation = customElements.get('page-navigation');
    if (!PageNavigation || PageNavigation.prototype.__hpMenuPatched) return !!PageNavigation;

    const originalAnimate = PageNavigation.prototype.animatePageTransition;

    PageNavigation.prototype.getPreviousPageTransition = function (page, direction) {
      return [
        [
          page,
          {
            transform: `translate3d(${direction === 1 ? '-100%' : '100%'}, 0, 0)`,
          },
          {
            duration: TRANSITION_MS / 1000,
            ease: 'power2.inOut',
          },
        ],
      ];
    };

    PageNavigation.prototype.getCurrentPageTransition = function (page, direction) {
      return [
        [
          page,
          {
            transform: [
              `translate3d(${direction === 1 ? '100%' : '-100%'}, 0, 0)`,
              'translate3d(0, 0, 0)',
            ],
          },
          {
            duration: TRANSITION_MS / 1000,
            ease: 'power2.out',
            at: '<',
          },
        ],
      ];
    };

    if (typeof originalAnimate === 'function') {
      PageNavigation.prototype.animatePageTransition = function (incoming, outgoing, direction) {
        // A page that was animated out earlier still carries the inline styles set below
        // (and the theme's fixed height); clear them so it scrolls again when it comes back.
        ['position', 'inset', 'width', 'height', 'overflow'].forEach((prop) => {
          incoming.style.removeProperty(prop);
        });

        outgoing.style.position = 'absolute';
        outgoing.style.inset = '0';
        outgoing.style.width = '100%';
        outgoing.style.height = '100%';
        outgoing.style.zIndex = '1';
        outgoing.style.overflow = 'hidden';
        incoming.style.zIndex = '2';

        return originalAnimate.call(this, incoming, outgoing, direction);
      };
    }

    PageNavigation.prototype.__hpMenuPatched = true;
    return true;
  };

  /**
   * "Patili Dostların" card: in test mode both states are rendered; show the one matching
   * the homepage "Sana Özel" demo toggle (sessionStorage "hp-customer-demo-view").
   * Outside test mode the server renders a single card and nothing is changed here.
   */
  const PET_VIEW_KEY = 'hp-customer-demo-view';

  const syncPetCards = () => {
    const cards = document.querySelectorAll('#MobileMenu [data-mm-pet-card][data-demo="true"]');
    if (!cards.length) return;

    let view = 'real';
    try {
      const saved = sessionStorage.getItem(PET_VIEW_KEY);
      if (saved === 'empty' || saved === 'filled') view = saved;
    } catch (_) {
      /* storage unavailable */
    }

    cards.forEach((card) => {
      const state = card.dataset.state;
      const real = card.dataset.real === 'true';
      const show = view === 'real' ? (state === 'filled') === real : state === view;
      card.hidden = !show;
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-hp-customer-view-btn], [data-modal="MobileMenu"]')) {
      setTimeout(syncPetCards, 0);
    }
  });

  const init = () => {
    patchMobileMenu();
    patchPageNavigation();
    applyDrawerStrategy(document.getElementById('MobileMenu'));
    syncPetCards();
  };

  if (!patchMobileMenu()) {
    customElements.whenDefined('mobile-menu').then(init);
  }

  if (!patchPageNavigation()) {
    customElements.whenDefined('page-navigation').then(patchPageNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
